import Welcome from "../components/Welcome";

const HomePage = () => {
    return (
        <Welcome />
    );
};


export default HomePage;